import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import SlideToConfirm from './SlideToConfirm';

type Props = {
  open: boolean;
  payoutId: number | null;
  amountVnd?: number | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

type Phase = 'ask' | 'swipe';

export default function PayoutCompleteConfirmWidget({ open, payoutId, amountVnd, busy, onClose, onConfirm }: Props) {
  const [phase, setPhase] = useState<Phase>('ask');


  if (!open || payoutId == null) return null;

  return (
    <div className="fixed inset-0 z-[240] flex items-center justify-center bg-black/45 p-4 backdrop-blur-[2px]">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-2xl">
        <div className="bg-gradient-to-r from-emerald-600 to-teal-700 px-5 py-4 text-white">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 rounded-lg bg-white/15 p-1.5">
              <CheckCircle2 className="h-5 w-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold" style={{ color: '#fff' }}>
                {phase === 'ask' ? 'Подтвердить оплату?' : 'Сдвиньте для подтверждения'}
              </h3>
              <p className="mt-1 font-mono text-xs text-emerald-100/95 tabular-nums">Payout #{payoutId}</p>
            </div>
          </div>
        </div>
        <div className="space-y-5 p-5">
          {phase === 'ask' ? (
            <>
              <div className="rounded-xl border border-emerald-200/75 bg-emerald-50/45 p-3.5 text-sm leading-relaxed text-emerald-950/90">
                Вы подтверждаете, что выплата фактически оплачена.
              </div>
              {typeof amountVnd === 'number' && amountVnd > 0 ? (
                <div className="rounded-xl border border-emerald-200/75 bg-emerald-50/45 p-3.5 text-sm text-emerald-950/90">
                  Сумма заявки: <strong>{Math.round(amountVnd).toLocaleString('ru-RU')} VND</strong>
                </div>
              ) : null}
              <div className="flex flex-wrap items-center justify-end gap-2 border-t border-slate-200/80 pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={busy}
                  className="rounded-xl border border-slate-200/90 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700"
                >
                  Отмена
                </button>
                <button
                  type="button"
                  onClick={() => setPhase('swipe')}
                  disabled={busy}
                  className="rounded-xl border border-emerald-500/35 bg-gradient-to-br from-emerald-600 to-teal-700 px-4 py-2.5 text-sm font-semibold text-white"
                >
                  Да, оплатил
                </button>
              </div>
            </>
          ) : (
            <>
              <SlideToConfirm disabled={busy} loading={busy} onConfirm={onConfirm} />
              <div className="flex flex-wrap items-center justify-between gap-2 border-t border-slate-200/80 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    if (!busy) setPhase('ask');
                  }}
                  disabled={busy}
                  className="text-sm font-semibold text-slate-500 underline decoration-slate-300 underline-offset-2"
                >
                  Назад
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  disabled={busy}
                  className="rounded-xl border border-slate-200/90 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700"
                >
                  Отмена
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
